import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	// border: '2px solid #000',
	borderRadius:'6px',
	boxShadow: 24,
	p: 2,
};

const JobFilledModal = ({
	memberSelection,
	memberSelectionFun,
	filledJob,
	open,
	setOpen,
}) => {
	const handleClose = () => setOpen(false);

	return (
		<div>
			<Modal
				keepMounted
				open={open}
				onClose={handleClose}
				aria-labelledby='keep-mounted-modal-title'
				aria-describedby='keep-mounted-modal-description'
			>
				<Box sx={style}>
					<Typography variant='h5' component='div' fontWeight="500" mb={2}>
						Select Applicant
					</Typography>
					<Typography   mt={2} mb={2}>Please select applicant's to fill this position</Typography>
					<Box>
						{memberSelection?.map((data, index) => (
							<Box key={index}>
								<input
									onChange={e => memberSelectionFun(e)}
									type='checkbox'
									id={index}
									name='members'
									value={data.id}
								/>
								<label htmlFor={`checkbox-${index}`}>
									&nbsp;&nbsp; {data.fullname}
								</label>
								<br />
							</Box>
						))}
					</Box>
					<Box display='flex' justifyContent="flex-end" gap={2} mt={3}>
						<Button
							className='w-48 fw-bold btn-logout'
							variant='contained'
							color='primary'
							onClick={filledJob}
						>
							Select Member
						</Button>
						<Button
							className='w-48 fw-bold btn-logout'
							variant='contained'
							color='error'
							onClick={handleClose}
						>
							Cancel
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default JobFilledModal;
